import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-open-button-sm',
  templateUrl: './open-button-sm.component.html',
  styleUrls: ['./open-button-sm.component.scss']
})
export class OpenButtonSmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
